<template>
    <span>
        <el-form-item :label="label" >
            <el-upload
                class="avatar-uploader"
                action="/extwarapi/api/file/fileUpload"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                >
                <img v-if="tpicUrl" :src="tpicUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
        </el-form-item>
    </span>
</template>

<script>
export default { 
    data(){
        return{          
            tpicUrl:this.objPicUrl
        }
    },
    props:{           
        picUrl: {
            type: String,
            default:''
        }, 
        objPicUrl: {
            type: String
        },      
        label:{
            type:String,
        }
    },
    methods:{
        handleAvatarSuccess(){

        },
    },
    watch: { 
        picUrl(newVal, oldVal) {
            if (newVal !== oldVal) {
                //this.$emit("changePicUrl", this.picUrl);
            }           
        },
        objPicUrl(newVal,oldVal){         
           if (newVal !== oldVal) {
                this.tpicUrl = newVal;
            }
        }
    }

}
</script>

<style lang="scss"  >
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 217px;
        height: 100px;
        line-height: 100px;
        text-align: center;
        border:1px dashed rgb(223, 215, 215);
    }
    .avatar{
        width: 215px;
        height: 120px
    }
</style>